// start:ng42.barrel
export * from './hotel-reservation-details.component';
// end:ng42.barrel



// WEBPACK FOOTER //
// ./src/main/webapp/stay-mgmt/app/components/hotel-reservation-details/index.ts